﻿import { FC } from 'react';
import { Section, Card, CardTitle, CardDescription, Alert, Button } from '../components/ui';
import { SEOHead } from '../components/seo';
import { ROUTES } from '../config/routes';
import { PageProps } from './HomePage';

export const PaymentFailedPage: FC<PageProps> = ({ onNavigate }) => {
  return (
    <>
      <SEOHead title="Payment Incomplete" noIndex={true} />
      <Section title="Payment Unsuccessful">
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          <Card>
            <Alert variant="error" title="Transaction Could Not Be Completed">
              The payment attempt was not captured or was cancelled. No charges were made to your account.
            </Alert>
            <CardTitle style={{ marginTop: '1rem' }}>Need Assistance?</CardTitle>
            <CardDescription style={{ marginTop: '0.5rem', lineHeight: 1.6 }}>
              You can retry checkout with a different payment method, or contact our support team.
            </CardDescription>
            <div style={{ marginTop: '1.5rem', display: 'flex', gap: '1rem' }}>
              <Button variant="primary" onClick={() => onNavigate(ROUTES.DIGITAL_PRODUCTS)}>
                Browse Products
              </Button>
              <Button variant="outline" onClick={() => onNavigate(ROUTES.CONTACT)}>
                Contact Support
              </Button>
            </div>
          </Card>
        </div>
      </Section>
    </>
  );
};

